import { Component, Input, Output, EventEmitter, OnInit, AfterContentChecked } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { TogetherAuctionDIPLoanDetails } from './../models/api.models';
import { NodeAPIEntityService } from './../services/node.entity.service';
import { TogetherAuctionDIPEntityType } from './../models/enums';
import * as _ from 'lodash-es';
import { DipStateService } from '../services/dip-state-service.service';

@Component({
    selector: 'together-auction-dip-apply',
    templateUrl: './dip.apply.component.html',
    providers: [NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPApplyComponent implements OnInit {
  tad_apply_property_type: UntypedFormControl = new UntypedFormControl(null, []);
  tad_apply_is_dip: UntypedFormControl = new UntypedFormControl(null, []);
  tad_apply_form: UntypedFormGroup;
  @Input() incoming_case_id: string;
  @Input() stage;
  @Output() stage_changing = new EventEmitter();
  @Output() parameters_added = new EventEmitter();
  loan_details: TogetherAuctionDIPLoanDetails = new TogetherAuctionDIPLoanDetails();

  _notifications: Array<object> = [];
  _isLoading: boolean = false;

  propertyTypeValueValid(tad_apply_property_type: string) {
    return (group: UntypedFormGroup): { [key: string]: any } => {
      const la = group.controls[tad_apply_property_type].value;

      return la != null ? null : {
        propertyTypeNotSelected: true,
      };
    };
  }


  /**
   * Disable the backward button.
   *
   * @readonly
   * @memberof TogetherAuctionDIPApplyComponent
   */
  get disableBackward() {
    return this.tad_apply_property_type.value !== 0 && this.tad_apply_property_type.value !== '0';
  }

  /**
   * Show pre-approval button.
   *
   * @readonly
   * @memberof TogetherAuctionDIPApplyComponent
   */
  get showPreApproval() {
    return this.tad_apply_property_type.value === 0 || this.tad_apply_property_type.value === '0';
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this._handleInit();
  }

  ngAfterContentChecked() {
    this._handleBindAPIData();
  }

  _handleDisableButtons() {
    return this.tad_apply_form.invalid === true;
  }

  _setErrorNotifications(notifications) {
    this._notifications = notifications;
  }

  _clearErrors() {
    this._notifications = [];
  }

  _handleError(error) {
    this._notifications.push({ text: error.error.message });
  }

  _handleBindAPIData() {
    this.loan_details.PropertyType = this.tad_apply_property_type.value;
  }

  _handleBindInitData() {
    this.tad_apply_property_type.setValue(this.loan_details.PropertyType);
  }

  _handleSaveData(case_id, entity_id, entity) {
    this._isLoading = true;
    this.api.saveEntities(TogetherAuctionDIPEntityType.LoanDetails, case_id, entity_id, entity)
      .subscribe(
        success => {
          this.loan_details = new TogetherAuctionDIPLoanDetails(success as Object);
          this._clearErrors();
          this._handleEmitForward(false);
          this._isLoading = false;
        },
        error => {
          this._handleError(error);
          this._isLoading = false;
        },
      );
  }

  _handleInitData(case_id) {
    this._isLoading = true;
    this.api.getAllEntities(TogetherAuctionDIPEntityType.LoanDetails, case_id)
      .subscribe(
        success => {
          this.loan_details = new TogetherAuctionDIPLoanDetails(success as Object);
          this._clearErrors();
          this._handleBindInitData();
          this._isLoading = false;
        },
        error => {
          this._handleError(error);
          this._isLoading = false;
        },
      );
  }

  _handleInit() {
    // Is the entity not new? If so, let's get the details.
    if (this.api.isNew(this.incoming_case_id) === false) {
      this._handleInitData(this.incoming_case_id);
    } else {
      // If we're not allowed to have a new reference, move.
      if (this.api.allowNew(this.stage.current_stage.reference) === false) {
        this.stage_changing.emit('tad_stage_info');
      }
    }
  }

  _handleEmitForward(include_parameters = false) {
    if (include_parameters) {
      this.parameters_added.emit({
        property_type: this.tad_apply_property_type.value,
        is_dip: this.tad_apply_is_dip.value,
      });
    }
    this.stage_changing.emit(this.stage.forward_stage.reference);
  }

  _handleForward() {
    this.tad_apply_is_dip.setValue(false);
    if (this.api.isNew(this.incoming_case_id) === false) {
      this._handleSaveData(this.incoming_case_id, null, this.loan_details);
    } else {
      this._handleEmitForward(true);
    }
  }

  _handleBackward() {
    this.tad_apply_is_dip.setValue(true);
    this.tad_apply_property_type.setValue(0);
    this.parameters_added.emit({
      property_type: this.tad_apply_property_type.value,
      is_dip: this.tad_apply_is_dip.value,
    });
    this.stage_changing.emit(this.stage.backward_stage.reference);
  }

  onChanges(): void {
    this.tad_apply_form.get('tad_apply_property_type').valueChanges.subscribe((val) => {
      this.state.propertyType.next(_.toInteger(val));
    });
  }

  constructor(private fb: UntypedFormBuilder, private api: NodeAPIEntityService, private state: DipStateService) {
    this.tad_apply_form = this.fb.group({
      tad_apply_property_type: this.tad_apply_property_type,
    }, { validator: this.propertyTypeValueValid('tad_apply_property_type') });

    // If we're here it's NEW but not a DIP and we'll nullify the property type till changed
    this.state.isDipJourney.next(false);
    this.state.propertyType.next(null);
    this.state.caseId.next('00000000-0000-0000-0000-000000000000');
    // Listen for changes on the form
    this.onChanges();
  }

}
